import { StatesModule } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { AccessGuardService } from '../auth/services/access-guard.service';
import { CanAccessAppsService } from '../auth/services/can-access-apps.service';
import { UrlStateService } from '../auth/services/url-state.service';
import { DISPLAY_ACCESS } from '../auth/types/access-level';
import { ViewportComponent } from './viewport/viewport.component';
import { ScreenSharingComponent } from './components/screen-sharing/screen-sharing.component';
import { ModeratorJoinComponent } from './components/moderator-join/moderator-join.component';
import { ModeratorRoomComponent } from './components/moderator-room/moderator-room.component';
import { ScreenSharingService } from './services/screen-sharing.service';

export const routes: StatesModule = {
  states: [
    {
      name: 'apps.screen-sharing',
      abstract: true,
      component: ViewportComponent,
      resolve: [
        {
          token: 'screenSharing',
          deps: [ScreenSharingService],
          resolveFn: (screenSharingService) =>
            screenSharingService.clearErrors(),
        },
      ],
    },
    {
      name: 'apps.screen-sharing.home',
      url: '/join?rvshare&joinCode&memberDisplayName',
      component: ScreenSharingComponent,
      data: {
        rvshareAppEnabled: true,
        requiresAuth: false,
      },
    },
    {
      name: 'apps.screen-sharing.moderator-join',
      url: '/screen-sharing/join/{folderId:any}?rvshare&tab',
      params: {
        // Dynamic: folder/tab URL changes do not destroy this view — onSuccess calls load().
        folderId: {
          dynamic: true,
          value: null,
        },
        tab: {
          dynamic: true,
          value: null,
        },
      },
      component: ModeratorJoinComponent,
      data: {
        rvshareAppEnabled: true,
        requiresAuth: false,
      },
      resolve: [
        {
          token: 'canAccess',
          deps: [CanAccessAppsService, UrlStateService],
          resolveFn: (
            canAccessAppsService: CanAccessAppsService,
            urlStateService: UrlStateService,
          ) => {
            const redirectTo = urlStateService.urlToState(
              '/screen-sharing/join',
            );
            return canAccessAppsService.canAccessApps(
              undefined,
              undefined,
              redirectTo,
            );
          },
        },
        {
          token: 'requireScreenSharingAccess',
          deps: [Transition, AccessGuardService],
          resolveFn: (transition, accessGuardService: AccessGuardService) =>
            accessGuardService.requireAccess(
              DISPLAY_ACCESS.SCREEN_SHARING_MODERATOR,
              transition,
            ),
        },
      ],
    },
    {
      name: 'apps.screen-sharing.moderator-room',
      url: '/screen-sharing/room/:displayId/:sessionId?rvshare&existingSession',
      params: {
        existingSession: { dynamic: true },
      },
      component: ModeratorRoomComponent,
      data: {
        rvshareAppEnabled: true,
      },
      resolve: [
        {
          token: 'requireScreenSharingAccess',
          deps: [Transition, AccessGuardService],
          resolveFn: (transition, accessGuardService: AccessGuardService) =>
            accessGuardService.requireAccess(
              DISPLAY_ACCESS.SCREEN_SHARING_MODERATOR,
              transition,
            ),
        },
      ],
    },
  ],
};
